// Unpublished Work © 2021-2025 Deere & Company.

import t from 'tcomb';
import {CustomerType} from '../../../enum/customer-type';
import {SearchQuery} from '../../customer-search/facets/search-query';

export const PreFilledFacets = t.struct({
    city: t.maybe(t.String),
    country: t.maybe(t.String),
    customerEntityId: t.maybe(t.String),
    customerTypes: t.maybe(t.list(CustomerType)),
    dbsNumber: t.maybe(t.String),
    email: t.maybe(t.String),
    firstName: t.maybe(t.String),
    phoneNumber: t.maybe(t.String),
    postalCode: t.maybe(t.String),
    states: t.maybe(t.list(t.String)),
    rewardsNumber: t.maybe(t.String),
    query: t.maybe(SearchQuery),
    orgId: t.maybe(t.String),
    crmId: t.maybe(t.String)
}, {
    defaultProps: {},
    name: 'PreFilledFacets',
    strict: true
});
